import { useResolveUsers } from '~/hooks/useResolveUsers';
import { PilotId } from '~/types/PilotId';

export const UserQuestionValue = ({ userIds }: { userIds: PilotId[] }) => {
  const { users } = useResolveUsers({ userIds });

  return (
    <>
      {users
        ? userIds
            .map((id) =>
              users[id] ? `${users[id].firstName} ${users[id].lastName}` : id,
            )
            .join(' • ')
        : null}
    </>
  );
};
